// extracted by mini-css-extract-plugin
module.exports =  {"YSelect":"YSelect__pqqda","small":"small__NJcAv"};